import React from 'react';
import { ApolloProvider } from '@apollo/client/react';

import Apollo from '../config/apollo';

const DataContextProvider = ({ cache, children }: any) => {
    const client = Apollo.getClient(cache);

    return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default DataContextProvider;
